<template>
  <v-dialog v-model="dialog" persistent width="500px" scrollable>
    <card :loading="loading" :disabled="loading">
      <card-title large closeable @click:close="dialog = false">
        {{ formTitle }}
      </card-title>
      <card-content>
        <validation-observer ref="validator">
          <edit-form
            v-model="formData"
            :action="formAction"
            :key-value="keyValue"
          />
        </validation-observer>
      </card-content>
      <card-actions>
        <v-spacer />
        <v-btn color="primary" depressed outlined @click="dialog = false">
          Отменить
        </v-btn>
        <v-btn color="primary" depressed @click="saveItem">
          Сохранить
        </v-btn>
      </card-actions>
    </card>
  </v-dialog>
</template>
<script>
import NotificationMixin from "@/mixins/NotificationMixin";
import Repository from "@/api/userdics.js";
import EditForm from "./EditForm.vue";

const formDataFactory = () => ({
  term: "",
  value: "",
  keyvalue: 0
});

export default {
  components: { EditForm },
  mixins: [NotificationMixin],
  model: {
    prop: "open",
    event: "change"
  },
  props: {
    open: Boolean,
    itemId: {
      type: Number,
      default: 0
    },
    dicId: {
      type: [Number, String],
      required: true
    },
    keyValue: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      formData: formDataFactory()
    };
  },
  computed: {
    dialog: {
      get() {
        return this.open;
      },
      set(value) {
        this.$emit("change", value);
      }
    },
    formAction() {
      return this.itemId ? "edit" : "create";
    },
    formTitle() {
      return this.itemId ? "Редактирование записи" : "Добавление записи";
    }
  },
  watch: {
    open(newVal) {
      if (newVal && this.itemId) {
        this.loadItem();
      } else if (!newVal) {
        this.resetForm();
        this.$emit("close");
      }
    }
  },
  methods: {
    async saveItem() {
      try {
        if (!(await this.$refs.validator.validate())) return;
        const { formData, itemId } = this;
        const payload = { ...formData };

        this.loading = true;

        const { data } = itemId
          ? await Repository.update(itemId, payload)
          : await Repository.create(this.dicId, payload);

        await this.$store.dispatch("fetchProfile");

        this.$emit("apply");
        this.sendAlert(data.alert);

        this.dialog = false;
      } finally {
        this.loading = false;
      }
    },
    async loadItem() {
      try {
        const { itemId, formData } = this;
        this.loading = true;
        const { data } = await Repository.getOne(itemId);
        this.formData = { ...formData, ...data };
      } finally {
        this.loading = false;
      }
    },
    resetForm() {
      this.formData = formDataFactory();
      if (this.$refs.validator) this.$refs.validator.reset();
    }
  }
};
</script>
